const KEY = "ph_cookie_consent";
const EVENT = "ph-consent-open";

export const GA_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();
export const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || "").trim();

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setConsent(value) {
  localStorage.setItem(KEY, JSON.stringify({ value, timestamp: new Date().toISOString() }));
  if (value === "all") loadTracking();
}

export function openConsentBanner() {
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function onConsentOpen(handler) {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}

let loaded = false;

export function loadTracking() {
  if (loaded || getConsent()?.value !== "all") return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
    s.setAttribute("data-consent", "analytics");
    document.head.appendChild(s);
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { anonymize_ip: true });
  }
  if (PIXEL_ID) {
    if (!window.fbq) {
      const n = (window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); });
      window._fbq = n; n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      s.setAttribute("data-consent", "marketing");
      document.head.appendChild(s);
    }
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

export function trackLead(lead) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "lead_submitted", tipologia: lead.tipologia, situazione: lead.situazione });
  if (getConsent()?.value !== "all") return;
  if (GA_ID && window.gtag) window.gtag("event", "generate_lead", { tipologia: lead.tipologia, situazione: lead.situazione });
  if (PIXEL_ID && window.fbq) window.fbq("track", "Lead");
}
